import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import MainLayout from './components/layout/MainLayout';
import RequireAuth from './components/RequireAuth';
import { Box, CircularProgress } from '@mui/material';

const BotConstructorPage = lazy(() => import('./components/bot-constructor/BotConstructorPage'));
const ChainEditorPage = lazy(() => import('./components/bot-constructor/ChainEditorPage'));
const ScenarioPreviewPage = lazy(() => import('./components/bot-constructor/ScenarioPreviewPage'));
const BroadcastsPage = lazy(() => import('./components/broadcasts/BroadcastsPage'));

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <Suspense
            fallback={
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
              </Box>
            }
          >
            <Routes>
              <Route element={<RequireAuth />}>
                <Route path="/" element={<MainLayout />}>
                  <Route index element={<Navigate to="/bot" replace />} />
                  <Route path="bot" element={<BotConstructorPage />} />
                  <Route path="bot/chain/:id" element={<ChainEditorPage />} />
                  <Route path="bot/chain/new" element={<ChainEditorPage />} />
                  <Route path="bot/preview/:id" element={<ScenarioPreviewPage />} />
                  <Route path="broadcasts" element={<BroadcastsPage />} />
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/bot" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
